<template>
  <div class="d-flex flex-column gap-4">
    <v-card rounded="lg" class="pa-3">
      <div class="d-flex align-center flex-wrap">
        <v-icon left> mdi-web </v-icon>
        <h5 class="mb-0 flex-grow-1">Site</h5>
        <fee-input-controller
          :value="fees"
          @input="updateFee"
          :organizationId="organizationId"
          :partyId="partyId"
          :ticketGroupId="ticketGroupId"
          :ticketBlockId="ticketBlockId"
          paymentMethod="PAGSEGURO"
        ></fee-input-controller>
      </div>
    </v-card>
    <v-card rounded="lg" class="pa-3">
      <div class="d-flex align-center flex-wrap">
        <v-icon left> mdi-account-cash </v-icon>
        <h5 class="mb-0 flex-grow-1">Promoter</h5>
        <fee-input-controller
          :value="fees"
          @input="updateFee"
          :organizationId="organizationId"
          :partyId="partyId"
          :ticketGroupId="ticketGroupId"
          :ticketBlockId="ticketBlockId"
          paymentMethod="OFFLINE"
          class="flex-grow-1 flex-md-grow-0"
        ></fee-input-controller>
      </div>
    </v-card>
    <v-card rounded="lg" class="pa-3">
      <div class="d-flex align-center flex-wrap">
        <v-icon left> mdi-printer-pos </v-icon>
        <h5 class="mb-0 flex-grow-1">POS</h5>
      </div>

      <div class="d-flex flex-column gap-2">
        <template v-for="(pt, key, i) in paymentTypes.POS">
          <v-divider v-if="i > 0" :key="`divider-${i}`"></v-divider>
          <div
            class="d-flex justify-space-between align-center flex-wrap flex- flex-md-row"
            :key="key"
          >
            <h6 class="mb-0 font-weight-bold" style="width: 80px">{{ pt }}</h6>
            <fee-input-controller
              :value="fees"
              @input="updateFee"
              :organizationId="organizationId"
              :partyId="partyId"
              :ticketGroupId="ticketGroupId"
              :ticketBlockId="ticketBlockId"
              paymentMethod="POS"
              :paymentType="key"
              class="flex-grow-1 flex-md-grow-0"
            ></fee-input-controller>
          </div>
        </template>
      </div>
    </v-card>
  </div>
</template>

<script>
import FeeInputController from "./FeeInputController.vue";
export default {
  components: { FeeInputController },
  props: {
    organizationId: {
      type: String,
      default: null,
    },
    partyId: {
      type: String,
      default: null,
    },
    ticketGroupId: {
      type: String,
      default: null,
    },
    ticketBlockId: {
      type: String,
      default: null,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    paymentTypes: {
      POS: {
        MONEY: "Dinheiro",
        PIX: "PIX",
        DEBIT_CARD: "Débito",
        CREDIT_CARD: "Crédito",
      },
    },
  }),
  methods: {
    updateFee(data) {
      const index = this.fees.findIndex(
        (fee) =>
          fee.paymentMethod === data.paymentMethod &&
          fee.paymentType === data.paymentType &&
          fee.organizationId === data.organizationId &&
          fee.partyId === data.partyId &&
          fee.ticketGroupId === data.ticketGroupId &&
          fee.ticketBlockId === data.ticketBlockId
      );
      if (index !== -1)
        this.fees = [
          ...this.fees.slice(0, index),
          data,
          ...this.fees.slice(index + 1),
        ];
      else this.fees = [...this.fees, data];
    },
  },
  computed: {
    fees: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style></style>
